import { IDeleteDocumentoUseCase } from "../../../presentation/useCases/delete/delete_documento_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";



export class DeleteDocumentoUseCase implements IDeleteDocumentoUseCase {
  constructor(
    private readonly repository: ITerceirizacaoRepository,
  ) { }

  async deleteDocumento(idDocumento: number): Promise<void> {
    await this.repository.deleteDocumento(idDocumento);
  }
}
